import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function SEO({ title, description, pathname = '' }) {
  const defaultTitle = 'Pålidelig godstransport og temperaturstyret logistik | Transport4U'
  const defaultDescription = 'Transport4U leverer professionel godstransport, temperaturstyret logistik (-20°C til +25°C) og ekspreslevering 24/7 med afgang inden for 2 timer. Ring 50 35 20 35.'
  
  const siteTitle = title || defaultTitle
  const siteDescription = description || defaultDescription

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      {pathname && <link rel="canonical" href={pathname} />}
    </Helmet>
  )
}
